import { useQuery } from 'react-query'

import { request } from '../api/apiCore'

const fetchAppModules = () => request({ url: '/admin/app_modules.json' })
export const useAppModulesData = () => useQuery('app_modules', fetchAppModules)
